export default "/images/vendor/@coreui/icons/svg/flag/cif-ua.svg?4898f7c605e3a7493c9f6c2e4f53dc51";